import { Box } from "@chakra-ui/react";
import React from "react";
import Topic from "../components/Topic";
const TopicScreen = () => {
  return (
    <Box>
      <Topic />
    </Box>
  );
};

export default TopicScreen;
